/**
 * Admin navigation items.
 * Used when the current page is an admin page (URL starts with /admin).
 *
 * Show predicates use trueUser* (not user.*) so that during impersonation
 * the admin keeps seeing their nav — current_user is the impersonated user
 * (no system role) but true_user is the actual admin operator.
 *
 * - trueUserAppAdmin (root + admin) — broad /admin/* surface
 * - trueUserSystem  (root + admin + content_manager) — Moments only
 */
export default [
  {
    label: 'Organizations',
    href: '/admin/organizations',
    urlPrefix: '/admin/organizations',
    show: (store) => store.trueUserAppAdmin
  },
  {
    label: 'Hubspot',
    href: '/admin/hubspot',
    urlPrefix: '/admin/hubspot',
    show: (store) => store.trueUserAppAdmin && store.wlc.appCodename === 'lo'
  },
  {
    label: 'Settings',
    href: '/admin/settings/onboarding_flows',
    urlPrefix: '/admin/settings',
    show: (store) => store.trueUserAppAdmin
  },
  {
    label: 'Mailer Log',
    href: '/admin/mailer-log',
    urlPrefix: '/admin/mailer-log',
    show: (store) => store.trueUserAppAdmin
  },
  {
    label: 'Data Migration',
    href: '/admin/data_migration_runs',
    urlPrefix: '/admin/data_migration_runs',
    show: (store) => store.trueUserAppAdmin && store.wlc.appCodename === 'lv'
  },
  {
    label: 'Moments',
    href: '/admin/moments',
    urlPrefix: '/admin/moments',
    show: (store) => store.trueUserSystem
  },
  {
    label: 'LSA Multi-Account',
    href: '/admin/lsa/team_accounts',
    urlPrefix: '/admin/lsa',
    show: (store) => store.trueUserSystem
  },
  {
    label: 'Alerts',
    href: '/admin/custom_alerts',
    urlPrefix: '/admin/custom_alerts',
    show: (store) => store.trueUserAppAdmin
  },
  {
    label: 'GeoCompare',
    href: '/admin/compare_providers/scan_sessions',
    urlPrefix: '/admin/compare_providers',
    show: (store) => store.trueUserAppAdmin
  }
]
